<ng-container *nzModalTitle>
  {{'admin.comments.modal.title' | translate}} {{account.salutation}} {{account.firstName}} {{account.lastName}} [{{account.email}}]
</ng-container>

<mh-account-comments [talentId]="account.accountId.internalId"></mh-account-comments>

